import React, { useState } from "react";

import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { AnimatePresence, m } from "motion/react";

import { useCasePropertiesUpdatedTable } from "src/cases/caseView/history/events/CasePropertiesTable";
import { HistorySingleEntry } from "src/cases/caseView/history/HistoryItemFrame";
import { InlineTable } from "src/cases/common/InlineTable";
import { useCase } from "src/cases/queries/cases";
import { CaseHistoryEvent } from "src/cases/queries/casesTypes";
import { CasePageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const CaseUpdated: React.FC<{
  entry: CaseHistoryEvent<"case_updated">;
  isLast: boolean;
}> = ({ entry, isLast }) => {
  const { case_id: caseId } = useParamsDecode<CasePageParams>();
  const { data: caseData } = useCase(caseId);

  const templateVersion = caseData?.data.template_version;

  const { updated_properties } = entry.event_data;

  const { columns, rows } = useCasePropertiesUpdatedTable(
    updated_properties,
    templateVersion,
  );

  const [isExpanded, setIsExpanded] = useState(false);

  const content = (
    <AnimatePresence initial={false}>
      {isExpanded && (
        <m.div
          animate={{ opacity: 1, height: "auto" }}
          // Hide the vertical scrollbar but keep the horizontal scrollbar
          className="decideScrollbar overflow-x-auto overflow-y-auto [&::-webkit-scrollbar:vertical]:w-0"
          exit={{ opacity: 0, height: 0 }}
          initial={{ opacity: 0, height: 0 }}
          layout
        >
          <InlineTable columns={columns} data={rows} />
        </m.div>
      )}
    </AnimatePresence>
  );

  return (
    <HistorySingleEntry
      content={content}
      eventType={entry.event_type}
      headline="Case data was updated."
      icon={faEdit}
      isExpanded={isExpanded}
      isLast={isLast}
      timestamp={entry.timestamp}
      onToggle={setIsExpanded}
    />
  );
};
